const draftShiftsToPublish = (shifts, includeOpenShifts) => {
    const publishableShifts = shifts.filter( (item) => 
      item.trade_status === 'unpublished_inventory' || 
      item.trade_status === 'unregistered_unpublished_inventory'  ||
      (item.trade_status === 'unpublished_posted' && includeOpenShifts)
  ); 
    return publishableShifts;
}

const isDraftShift = (shift) => {
  if( shift?.trade_status === 'unpublished_inventory' ||
      shift?.trade_status === 'unregistered_unpublished_inventory' ||
      shift?.trade_status === 'unpublished_posted' ) {
        return true;
    }else{
      return false;
    }
}

const isDraftOpenShift = (shift) => {
  if ( shift?.trade_status === 'unpublished_posted' && shift?.name === 'open_shift')  {
    return true;
  }else{
    return false;
  }
}

const isDraftVTO = (shift) => {
  if ( shift?.trade_status === 'unpublished_posted' && shift?.name === 'shift_vto')  {
    return true;
  }else{
    return false;
  }
}

const isOpenShift = (shift) => {
  if ( shift?.name === 'open_shift')  {
    return true;
  }else{
    return false;
  }
}

const isVTO = (shift) => {  
  if ( shift?.name === 'shift_vto')  {
    return true;
  }else{
    return false;
  }
}

export default {
    draftShiftsToPublish,
    isDraftShift,
    isDraftOpenShift,
    isDraftVTO,
    isOpenShift,
    isVTO,
}